<template>
    <div>
         <v-toolbar dense flat color="transparent" v-if="count>0">
          <v-toolbar-title class="blue--text text--darken-1 subtitle-1">Algemene vragenlijst</v-toolbar-title>
          <v-spacer></v-spacer>
             </v-toolbar>
    
         <v-list subheader dense v-if="group==true" color="transparent">
              <template v-for="tag in tags">
                  <v-subheader v-if="available.filter(q => q.linkto.indexOf(tag.tag) > -1).length > 0" class="primary--text pl-4">{{tag.name}}</v-subheader>
                  <template v-for="(question, ii) in available.filter(q => q.linkto.indexOf(tag.tag) > -1)">
                  <v-hover v-slot:default="{ hover }">
                          <v-list-item
                  @click="addThis(question)"
                 
                >
                  <!--v-list-item-icon v-if="!Role(`admin`) || !isMain" class="my-0 mr-2">
                       <v-btn icon small @click="addThis(question)" >
                        <v-icon color="primary">chevron_left</v-icon>
                      </v-btn>
                    </v-list-item-icon-->
                  <v-list-item-content class="my-0 py-0">
                    <v-list-item-title class="my-0 py-0" style=";white-space: normal;" >{{question.title}}</v-list-item-title>

                   <!--v-list-item-subtitle v-if="question.description">{{question.description}}</v-list-item-subtitle-->
                   <!--v-list-item-subtitle v-if="question.options">{{ question.options.join(', ') }}</v-list-item-subtitle-->
                  </v-list-item-content>
      <v-list-item-action v-if="question.duration && question.duration > 0">
                        {{question.duration}} min
                        </v-list-item-action>
                </v-list-item>
                    </v-hover>
                    </template>
                </template>
          </v-list>
        <v-list subheader dense v-else color="transparent">
                  <template v-for="(question, ii) in available2">
                  <v-hover v-slot:default="{ hover }">
                          <v-list-item
                  @click="addThis(question)"
                 
                >
                  <!--v-list-item-icon v-if="!Role(`admin`) || !isMain" class="my-0 mr-2">
                       <v-btn icon small @click="addThis(question)" >
                        <v-icon color="primary">chevron_left</v-icon>
                      </v-btn>
                    </v-list-item-icon-->
                  <v-list-item-content class="my-0 py-0">
                    <v-list-item-title class="my-0 py-0" tyle="font-size: 0.875rem" >{{question.title}}</v-list-item-title>
                    
                   <!--v-list-item-subtitle v-if="question.description">{{question.description}}</v-list-item-subtitle-->
                   <!--v-list-item-subtitle v-if="question.options">{{ question.options.join(', ') }}</v-list-item-subtitle-->
                  </v-list-item-content>
                       <v-list-item-action v-if="hover">
                        <v-btn small style="position:absolute;margin-top:-15px;margin-left:-80px;">TOEVOEGEN</v-btn>
                        </v-list-item-action>
                          <v-list-item-action v-else-if="question.duration && question.duration > 0" class="overline">
                        {{question.duration}} min
                        </v-list-item-action>
                </v-list-item>
                    </v-hover>
                    </template>
          </v-list>
         
    </div>
</template>
<script>

import axios from 'axios'

import {
  mapState, mapMutations, mapActions, mapGetters
} from 'vuex'
import templateList from "@/templateList";
export default {
  props: ['isMain','group','searchOnly'],
   data: () => ({
    loading: true,
    search123: '',
    allss: false}),
  computed: {
     ...mapGetters('auth', ["Role","maincontact","relation"]),
    ...mapState('auth', ["settings"]),
     ...mapState('app', ["template","edit","chat","preview"]),
    ...mapState('match', ["selected", "templates","taglist","search"]),
    showTemplate: {
      get() {
        return this.template && !this.preview
      },
      set(value) {
        this.setTemplate(value)
      }
      },
    available () {
        var self = this
        return this.templates.filter(
            q => 
            q.answer &&
            self.selected.questions.filter(t => t.title == q.title).length==0
            && (!self.search || self.search.length == 0
                || q.title.toUpperCase().indexOf(self.search.toUpperCase()) > -1 
                || q.linkto.filter(l => l.indexOf(self.search.toLowerCase()) > -1).length > 0
                )
            )
    },
    available2 () {
        var self = this
        if (this.searchOnly && !this.search) return this.settings.questions.filter(
            q => 
            self.selected.questions.filter(t => t.title == q.title).length==0)
        if (this.searchOnly) return this.templates.filter(
            q => 
            self.selected.questions.filter(t => t.title == q.title).length==0
            && (
                q.title.toUpperCase().indexOf(self.search.toUpperCase()) > -1 
                || q.linkto.filter(l => l.indexOf(self.search.toLowerCase()) > -1).length > 0
               )
               
            )
        return this.templates.filter(
            q => 
            (q.answer || this.Role('lead')) &&
            self.selected.questions.filter(t => t.title == q.title).length==0
            && (!self.search
                || q.title.toUpperCase().indexOf(self.search.toUpperCase()) > -1 
                || q.linkto.filter(l => l.indexOf(self.search.toLowerCase()) > -1).length > 0
               && q.linkto.filter(value => self.tagNames.includes(value)).length > 0 )
               
            )
    },
   
    count () {
      return this.available2.length  
    },
    all () {
        if (this.search && this.search.length > 0) return true
        return false
      },
    questions () {
        var self = this, qs = this.templates
        if (self.search && self.search.length > 0) {
            qs = qs.filter(q => q.title.toUpperCase().indexOf(self.search.toUpperCase()) > -1 || q.linkto.indexOf(self.search.toLowerCase()) > -1)
        } else if (!this.all){
         qs = this.templates.filter(
            q => self.selected.questions.filter(t => t.title == q.title).length==0
            && q.linkto.filter(value => self.tags.includes(value)).length > 0
            && !self.tags.includes(q.tag)
            && !self.tags.includes(q.notag)
            )
        }
        if (this.Role('admin') && this.isMain || this.all) {
            qs =  qs.filter(
            q => self.selected.questions.filter(t => t.title == q.title).length==0)
        }
        return qs
      },
    tags (){
       var tl = this.taglist
        var extra = []
       if (this.selected.tags && !this.all) tl =  this.selected.tags.filter(q=> q.type=='branche' || q.type=='category' || q.type=='type').map(t => {
            if (t.type == 'category' || t.type == 'type') {
                t.path = t.path.replaceAll(' / ', '###')
                t.name = t.path.split('/').map(c => c.capitalize()).join(', ').replaceAll('###',' / ')
                extra.push({type: 'branche', tag: t.path.split('/')[0].replaceAll('###',' / ') , name: t.path.split('/')[0].capitalize().replaceAll('###',' / ')})
            }
            return t
        }) //
        tl = tl.concat(extra)
        return tl
      },
     tagNames (){
         var tn = []
         var extra = []
       if (this.selected.tags) {
           tn = this.selected.tags.filter(q=> q.type=='branche' || q.type=='category' || q.type=='type').map(t => {
            if (t.type == 'category' || t.type == 'type') {
                t.path = t.path.replaceAll(' / ', '###')
                extra.push(t.path.split('/')[0].replaceAll('###',' / '))
                if (t.path.split('/').length > 0) {
                    extra.push(t.path.split('/')[0].replaceAll('###',' / ') + '&' + t.path.split('/')[1].replaceAll('###',' / '))
                    extra.push(t.path.split('/')[1].replaceAll('###',' / '))
                }
            }
            return t.tag
        }) //
            let type = this.selected.tags.filter(q => q.type == 'type')[0]
            let branche = this.selected.tags.filter(q => q.type == 'branche')[0]
            let category = this.selected.tags.filter(q => q.type == 'category')[0]
            if (branche && category) extra.push(branche + '&' + category)
            if (category && type) extra.push(category + '&' + type)
            if (branche && type) extra.push(branche + '&' + type)
            if (branche && category && type) extra.push(branche + '&' + category + '&' + type)
            tn = tn.concat(extra)
       }
        return tn
      },
    selectedTags () {
        var tags = []
         //
         if (this.selected.tags) {
            var tags = this.settings.tags.map(t => t.tag) //.filter(q=> q.type=='branche' || q.type=='category')
            if (this.selected.tags) tags = this.selected.tags.map(t => t.tag) //.filter(q=> q.type=='branche' || q.type=='category')
            if (this.selected.tags) this.selected.tags.filter(q=> q.type=='category' || q.type=='type').map(t => {
                t.path = t.path.replaceAll(' / ', '###')
                tags.push(t.path.split('/')[0].replaceAll('###',' / '))
            })
         }
        return tags
      }
  },
  mounted () {
    this.load();     
  },
  watch: {
     selected (selected,old) {
         var self = this
         this.$nextTick(() => {
            if (selected.tags) self.filter()
             if (self.selected.questions.length == 0) {
                 setTimeout(() => {  
                     if (self.Role("_admin,lead")){
                        self.addAll()
                        if (self.selected.questions.length>0){
                            self.setMenu(false)
                            self.setPreview(false)
                        }
                     }
                 }, 3000)
             }else {
                 self.setMenu(true)
                 self.setPreview(true)
                    
             }
         })
         
         
      } ,
      available (value) {
          
      },
      search (s,o){
          
          this.$emit('setAll', (s !=''))
      }
    },
  methods: {
      ...mapMutations('app', ["setTemplate","setMenu","setPreview"]),
     ...mapMutations('match', ["addAnswer","setSelected", "setTemplates","setTags"]),
     ...mapActions('match', ["addQuestion"]),
     load () {
         this.$emit('setAll', false)
          var self = this
          var list = []
          var taglist = []
          //axios.get(this.$config.templates).then(response => {
          //response.data.feed.entry.
              templateList.forEach(function(entry){
                var p = {match: [], linkto: [],target:''  }
                for (var property in entry) {
                    if (entry.hasOwnProperty(property)) {
                        //if (property.indexOf('$') > -1) {
                        var label = property.replaceAll('-','')//split('$')[1]
                         var value = entry[property]//.$t
                         if (value && (value.toString().indexOf(';')>-1 || label == 'linkto')) value = value.split(';')
                         //if (isNumeric(value)) value = value*1
                         if (value && value != "") p[label] = value// do stuff
                        //}
                    }
                }
                var q = {
                  title: p.question,
                  title_supplier: p.questionsupplier, 
                  match: p.match,
                  options: p.labels,
                  checks: [],
                  type: p.type,
                  tag: p.tag,
                  tagname: p.name,
                  notag: p.notag,
                  answer: p.reportanswer,
                  no_answer: p.reportnoanswer,
                  linkto: p.linkto,
                  duration: p.duration || 0,
                  default: p.default || false,
                  description: p.description
                }
                p.linkto.map(l => taglist.filter(t => t.name.toLowerCase() == l).length == 0 ? taglist.push({tag: l, name: l.capitalize()}) : l)
                
                //if (q.options[0] == 'JA') q.options.push("Optioneel")
                //if (self.Role('lead') && p.questionsupplier) q.title =  p.questionsupplier
                if (p.target.indexOf('supplier') > -1 && self.Role('_lead')) list.push(q)
                if (p.target.indexOf('lead') > -1 && !self.Role('_lead')) list.push(q)
                
              })
              this.setTags(taglist)
              this.setTemplates(list)
              if (list.length == 0) this.showTemplate = false
              self.loading = false
          //})
      },
      filter () {
          var self = this
          this.templates.forEach(function(q){
              if (self.Role('lead') && self.isMain) {
                  self.addItem(q) 
              } else if (!self.isMain) {
                  self.addItem(q) 
              }
          })
      },
      taggedItem(tag) {
          return self.selected.questions.filter(t => t.linkedto.indexOf(tag) > -1)
      },
      addItem(q) {
            var col = -1
            if (this.tags.includes(q.tag)) col = 0
            if (this.tags.includes(q.notag)) col = 1
            if (col == -1 ) return false
            if (q.options) {
                if (col > -1) q.value = q.options[col]
            }
            //if (this.selected.questions.filter(item => item.title == q.title ).length > 0) return false
            this.addQuestion(q)
        
            var a = { 
                    date: new Date(),
                    options: [],
                    owner: {email: this.maincontact.email, name: this.maincontact.name}, 
                    question: q.title,
                    score: 2}
            if (q.options) a.options.push(q.options[col])
            this.addAnswer(a)
    },
    addThis(question){
        question = Object.assign({}, question)
        this.addQuestion(question)
        if (question.tag) this.templates.filter(q => q.linkto.indexOf(question.tag)>-1).map(q => {q.optional = true;this.addQuestion(q)}) 
        if (question.notag) this.templates.filter(q => q.linkto.indexOf(question.notag)>-1).map(q => {q.optional = true;this.addQuestion(q)}) 
        this.$emit('add')
    },
    addAll() {
        var self = this
        console.log('addall', this.all)
      if (!this.all){
        var tt = this.available.filter(q => q.default &&
        q.linkto.filter(value =>self.tagNames.includes(value)).length > 0)
        if (this.Role("lead")) tt = tt.concat(this.available2.filter(q => q.default)) 
        console.log(tt)
        tt.map(q => this.addQuestion(q))
       this.$emit('addall')
      }
    },
      close () {
          this.setTemplate(false)
      }
  }
}
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
</script>